'use client';

import { Fragment, type ReactNode } from 'react';
import { useModalQueue } from '$util/hooks/useModalQueue';
import { Button } from '@/components/atoms/Button';

export interface GetHelpModalProps {
  readonly toggleButtonText: string;
  readonly modalContent: ReactNode;
}

export default function GetHelpModal({ toggleButtonText, modalContent }: GetHelpModalProps): JSX.Element {
  const [, queueModal] = useModalQueue();

  const toggleModal: React.MouseEventHandler = () => {
    queueModal([<Fragment key="modal-content">{modalContent}</Fragment>, 'modal']);
  };

  return <Button onClick={toggleModal}>{toggleButtonText}</Button>;
}
